var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("基本配置")]),
            ]),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [_vm._v("客户黑名单")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "content" }, [
      _c("h2", [_vm._v("客户黑名单")]),
      _c("h3", [_vm._v("数据筛选")]),
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              staticClass: "search-form",
              attrs: { inline: true, id: "search", size: "small" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "客户姓名" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入客户姓名", clearable: "" },
                    model: {
                      value: _vm.search.customerName,
                      callback: function ($$v) {
                        _vm.$set(_vm.search, "customerName", $$v)
                      },
                      expression: "search.customerName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "客户电话" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入客户电话" },
                    model: {
                      value: _vm.search.customerPhone,
                      callback: function ($$v) {
                        _vm.$set(_vm.search, "customerPhone", $$v)
                      },
                      expression: "search.customerPhone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "入线方式" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择入线方式", clearable: "" },
                      model: {
                        value: _vm.search.userDitch,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "userDitch", $$v)
                        },
                        expression: "search.userDitch",
                      },
                    },
                    _vm._l(_vm.userDitchList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "跟进客服" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择跟进客服",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.search.customerServiceUserId,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "customerServiceUserId", $$v)
                        },
                        expression: "search.customerServiceUserId",
                      },
                    },
                    _vm._l(_vm.salesAuthorityList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.reallyName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "类型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择类型", clearable: "" },
                      model: {
                        value: _vm.search.payType,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "payType", $$v)
                        },
                        expression: "search.payType",
                      },
                    },
                    _vm._l(
                      _vm.dictionaries.customer_channel_pay_type,
                      function (item) {
                        return _c("el-option", {
                          key: item.dictId,
                          attrs: { label: item.dictName, value: item.dictId },
                        })
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "部门" } },
                [
                  _c("el-cascader", {
                    attrs: {
                      options: _vm.orgCodeList,
                      props: {
                        checkStrictly: true,
                        label: "orgName",
                        value: "orgCode",
                        children: "children",
                      },
                      clearable: "",
                      filterable: "",
                    },
                    model: {
                      value: _vm.search.modelOrgCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.search, "modelOrgCode", $$v)
                      },
                      expression: "search.modelOrgCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "创建时间" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "unlink-panels": "",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      format: "yyyy-MM-dd",
                      "value-format": "yyyy-MM-dd",
                    },
                    on: { change: _vm.onChangeDate },
                    model: {
                      value: _vm.date,
                      callback: function ($$v) {
                        _vm.date = $$v
                      },
                      expression: "date",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fetchData("search")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.fetchData("reset")
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("h3", [_vm._v("客户黑名单列表")]),
        _c("lb-table", {
          directives: [
            {
              name: "horizontal-scroll",
              rawName: "v-horizontal-scroll",
              value: _vm.always,
              expression: "always",
            },
          ],
          attrs: {
            column: _vm.column,
            data: _vm.list,
            pagination: "",
            total: _vm.page.totalNum,
            layout: "total, sizes, prev, pager, next, jumper",
            "page-sizes": [5, 10, 20, 30, 50],
            "current-page": _vm.page.currentPage,
            "page-size": _vm.page.pageSize,
          },
          on: {
            "update:currentPage": function ($event) {
              return _vm.$set(_vm.page, "currentPage", $event)
            },
            "update:current-page": function ($event) {
              return _vm.$set(_vm.page, "currentPage", $event)
            },
            "size-change": _vm.handleSizeChange,
            "p-current-change": _vm.handleCurrentChange,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }